[{"phone":"","name":"","bonus":""}]
<template>
  <div class="wrapper">
    <el-card class="box-card specials">
      <div class="nav_list">
        <el-form-item :label="'特殊设置'">
          <p class="item_title">序号</p>
          <p class="item_title">中奖手机号</p>
          <p class="item_title">奖项</p>
          <p class="item_title">奖品(美元)</p>
        </el-form-item>
      </div>
      <div class="text" v-for="(card,index) in update.col.data">
        <div slot="header" class="clearfix titleCon">
          <div v-if="!readonly" class="btn-list">
            <el-button type="text" @click="addReward()">{{$t('crs.bt.add')}}</el-button>
            <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('crs.bt.delete')}}</el-button>
          </div>
        </div>
        <div class="item">
          <div class="item-table">
            <el-form-item :label="String(index+1)" >
              <el-input class="item-input" controls-position="right" v-model="card.phone" :required="true" :disabled="readonly" :placeholder="'中奖手机号'"></el-input>
              <el-input class="item-input" controls-position="right" v-model="card.bonus" :required="true" :disabled="readonly" :placeholder="'奖项'"></el-input>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.name"  :required="true" :placeholder="'奖项'" :disabled="readonly"></el-input-number>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  require('@/views/crs36/luckyDraw/template.css')
  import condition from '@/views/crs36/luckyDraw/condition.vue'
  export default {
    name: 'specials',
    props:["update"],
    components: {
      condition
    },
    methods: {
        addReward(){
            this.update.col.data.push({"phone":"","name":"","bonus":""});
        },
        delReward(index){
            this.update.col.data.splice(index, 1);
        }
    },
    computed:{
        readonly(){
            return (this.update.updateModel.id && this.update.updateModel.isBy == 1)?true:false;
        }
    },
    data () {
      return {
          taskList: [],
      }
    }
  }
</script>
<style scoped>
.nav_list .item_title{
  display: inline-block;
  float: left;
  width: 30.5%;
}
</style>
